module.exports = __webpack_public_path__ + "static/various2-bf1a3edfb24960aa5f130a657dcfd66f.png";